module.exports = __webpack_public_path__ + "img/cocteleria_4.b502124c.jpeg";